import {FC} from "react";
import {Button, Dialog, DialogActions, DialogContent, styled} from "@mui/material";

interface IProps {
	onClose: () => void;
	onAccept: () => void;
}

const ConfirmUnsavedChangesDialog: FC<IProps> = ({
	onClose,
	onAccept
}) => {
	return (
		<Dialog
			open={true}
			title="Leave page"
		>
			<DialogContent
				sx={(theme) => ({
					backgroundColor: theme.palette.background.paperElevation4
				})}
			>
				Are you sure that you want to leave the current page? The changes that you made won&apos;t be saved.
			</DialogContent>
      		<DialogActions
				sx={(theme) => ({
					paddingTop: 0,
					backgroundColor: theme.palette.background.paperElevation4
				})}
			>
        		<ButtonStyled
					variant="text"
					aria-label="Cancel action"
					onClick={onClose}
        		>
					Cancel
        		</ButtonStyled>
          		<ButtonStyled
					variant="text"
					aria-label="Confirm action"
					onClick={onAccept}
          		>
            		Leave
          		</ButtonStyled>
      		</DialogActions>
		</Dialog>
	)
}

const ButtonStyled = styled(Button)(({theme}) => ({
	border: "none",
	color: theme.palette.primary.main,
	"&:hover": {
		backgroundColor: "transparent"
	}
}))

export default ConfirmUnsavedChangesDialog;